import React, { useState } from "react";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { storePush } from "../../actions/store_cargo_order/store_cargo_order";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import MDProgress from "../../components/MDProgress";
import MDProgressRoot from "../../components/MDProgress/MDProgressRoot";
import { CircularProgress } from "@mui/material";

export default function CargoOrderPage() {
  const router = useNavigate();
  const [pending, setLoading] = useState(false);
  async function storePushNotif(e) {
    e.preventDefault();
    const toastId = toast.loading("درحال ارسال به اپراتور ها...");
    const formData = new FormData(e.target);
    setLoading(true);
    const state = await storePush(formData);
    toast.dismiss(toastId);

    setLoading(false);
    if (state.status === "success") {
      toast.success("دستور بار ارسال شد!");
      router("/");
    } else {
      toast.error(state.message);
    }
  }
  return (
    <DashboardLayout>
      <div
        className="flex items-center p-4 mb-4 text-sm text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300 dark:border-yellow-800"
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 me-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Info</span>
        <div>
          <span className="font-medium"> توجه! </span>
          دستور بار از طریق نوتیفیکیشن به اپراتور ها ارسال خواهد شد
        </div>
      </div>

      <div className="flex flex-col gap-9">
        <form onSubmit={storePushNotif}>
          <div className="rounded-sm border p-5 border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className="border-b border-stroke px-6.5 py-4 dark:border-strokedark">
              <h3 className="font-medium text-black dark:text-white">فرم ارسال دستور بار</h3>
            </div>
            <div className="flex flex-col gap-5 p-6">
              <div className="flex flex-wrap gap-5">
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    عنوان
                  </label>
                  <input
                    type="text"
                    name="title"
                    placeholder="..."
                    className="w-full rounded-lg text-sm border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />
                </div>
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    پیام
                  </label>
                  <input
                    name="message"
                    type="text"
                    placeholder="..."
                    className="w-full rounded-lg text-sm border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />
                </div>
              </div>

              <div className={"flex mt-10 w-1/5"}>
                {pending ? (
                  <MDButton disabled color="info" variant="gradient" fullWidth>
                    <CircularProgress size={25} color={"white"} />
                  </MDButton>
                ) : (
                  <MDButton type={"submit"} color="info" variant="gradient" fullWidth>
                    ثبت و ذخیره
                  </MDButton>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
}
